var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"text-center text-lg p-1 text-white",class:_vm.css},[(_vm.male)?_c('i',{staticClass:"fas fa-mars"}):_c('i',{staticClass:"fas fa-venus"})])
}
var staticRenderFns = []

export { render, staticRenderFns }